import PropTypes from 'prop-types';

import style from './MessageTitle.scss';

export const MessageTitle = ({ messageType, title, extraClassName = '' }) => (
  <div className={`${style.MessageTitle} ${extraClassName}`} data-testid="MessageTitle">
    <div className={`${style.icon} ${style[messageType]}`} />
    <h4 className={style.titleText}>{title}</h4>
  </div>
);

MessageTitle.propTypes = {
  messageType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  extraClassName: PropTypes.string,
};
